import { render, staticRenderFns } from "./BenefitCouponsTable.vue?vue&type=template&id=5bd2bd65&scoped=true"
import script from "./BenefitCouponsTable.vue?vue&type=script&lang=js"
export * from "./BenefitCouponsTable.vue?vue&type=script&lang=js"
import style0 from "./BenefitCouponsTable.vue?vue&type=style&index=0&id=5bd2bd65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd2bd65",
  null
  
)

export default component.exports